module.exports = __webpack_public_path__ + "static/media/calm_sad.0715512e.svg";